import { __decorate, __metadata } from "tslib";
import { Component, Prop, Provide, Ref } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import { LoaderTask } from "../../plugins";
import { ScriptLoader } from "@fastoche/ui-core/util/script-loader";
import styles from "./styles.json";
/**
 * Injection symbol provided by the LvMap component
 */
export const SYM_LV_MAP = Symbol("LvMap");
export const COMPONENT_NAME = "LvMap";
/**
 * A map component, based on Google Maps.
 */
let LvMap = class LvMap extends UIComponent {
    constructor() {
        super(...arguments);
        this.mapInstance = null;
    }
    get self() {
        return this;
    }
    /**
     * The instance of the native map.
     */
    get map() {
        return this.mapInstance;
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        await this.loadLibrary();
        this.mapInstance = new google.maps.Map(this.container, {
            styles: styles,
            ...this.options,
        });
    }
    async loadLibrary() {
        if ("google" in window && "maps" in window.google) {
            return;
        }
        await ScriptLoader
            .default
            .loadScript(`https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`);
    }
};
__decorate([
    Prop({ type: String, required: true }),
    __metadata("design:type", String)
], LvMap.prototype, "apiKey", void 0);
__decorate([
    Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], LvMap.prototype, "options", void 0);
__decorate([
    Provide(SYM_LV_MAP),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LvMap.prototype, "self", null);
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvMap.prototype, "container", void 0);
__decorate([
    LoaderTask,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], LvMap.prototype, "initialize", null);
LvMap = __decorate([
    Component({
        name: COMPONENT_NAME,
        loader: true,
    })
], LvMap);
export default LvMap;
//# sourceMappingURL=script.js.map